import React, { useState, useImperativeHandle, useRef, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './DynamicLinkList.module.css';

/**
 * DynamicLinkList
 * - 링크를 동적으로 추가하고 각 링크를 클릭할 때 특정 동작을 수행합니다.
 * @type React.FC<DynamicLinkListPropTypes>
 */
const DynamicLinkList = forwardRef((props, ref) => {
  const [links, setLinks] = useState([]); // 링크 목록 상태

  // 외부에서 접근할 수 있는 함수들
  useImperativeHandle(ref, () => ({
    /** 링크 추가 함수 */
    addLink(text, key) {
      if (text?.trim()) {
        const newLink = { text, key }; // 링크 객체 생성
        setLinks((prevLinks) => [...prevLinks, newLink]); // 링크 목록에 새로운 링크 추가
      }
    },
    /** 모든 링크 삭제 함수 */
    clear() {
      setLinks([]);
    },
    getValue() {
      return links;
    },
  }));

  // 링크 클릭 이벤트
  const handleLinkClick = (key) => {
    if (props.onLinkClick) {
      props.onLinkClick(key); // 클릭된 링크의 key를 부모 컴포넌트로 전달
    }
  };

  return (
    <div className={styles.dynamicLinkList}>
      <div >
        {links.map((link) => (
          <span
            key={link.key}
            onClick={() => handleLinkClick(link.key)} // 클릭 시 링크의 key 전달
            className={styles.link}
          >
            {link.text}
          </span>
        ))}
       </div>
    </div>
  );
});

const DynamicLinkListPropTypes = {
  /**
   * 링크 클릭 시 호출되는 함수
   * @param {number} key - 링크의 고유 key
   */
  onLinkClick: PropTypes.func,
};

DynamicLinkList.propTypes = DynamicLinkListPropTypes;
DynamicLinkList.defaultProps = {
  onLinkClick: null,
};

export default DynamicLinkList;